import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "vue3-toastify/dist/index.css";
import Vue3Toastify, { toast, type ToastContainerOptions } from "vue3-toastify";

const app = createApp(App);
const pinia = createPinia();
import "./utils/axios";
app.use(pinia);
pinia.use(piniaPluginPersistedstate);
localStorage.removeItem("project");
app.use(ElementPlus);
app.use(Vue3Toastify, {
  autoClose: 6000,
  position: toast.POSITION.TOP_RIGHT,
  newestOnTop: true,
  theme: "light",
} as ToastContainerOptions);
app.use(router).mount("#app");
